import { hasConditionalDiscount } from "@/helpers/conditionalDiscounts";

const selectedProducts = () => range => {
  let products = [];

  if (range.electricity)
    products.push(range.electricity);

  if (range.gas)
    products.push(range.gas);

  return products;
}

const sameOptions = (state, getters) => rangeName => {
  let sameOptions = true;
  let range = state.ranges.find(range => range.range === rangeName);

  let products = getters.selectedProducts(range);

  if(products.length > 1)
    sameOptions = products[1].peer && products[0].id === products[1].peer;

  return sameOptions;
}

const availableTypes = state => product => {
  let products = state.products.filter(x => {
    return (
      x.range === product.range &&
      x.energyType === product.energyType &&
      x.contractType !== product.contractType
    )
  });

  return products;
}

const availableDurations = state => product => {
  let products = state.products.filter(x => {
    return (
      x.range === product.range &&
      x.energyType === product.energyType &&
      x.duration !== product.duration &&
      x.contractType === product.contractType
    )
  });

  return products;
}

const getById = state => (id, duration) => {
  return state.products.find(product => {
    return product.productId.toString() === id.toString() && (product.duration === duration || duration === 0)
  });
}

const hasDiscount = state => {
  let hasAnyDiscount = product => !!product && (!!product.subtotal.discount || hasConditionalDiscount(product));

  return state.ranges && state.ranges.some(range => hasAnyDiscount(range.electricity) || hasAnyDiscount(range.gas))
}

export default {
  selectedProducts,
  sameOptions,
  availableTypes,
  getById,
  availableDurations,
  hasDiscount
};



// WEBPACK FOOTER //
// ./src/store/modules/offer/getters.js